import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { UserSettingsAction } from './userSettings.action';
import { initialState } from './userSettings.constant';

export const userSettingsReducer = reducerWithInitialState(initialState)
  .case(UserSettingsAction.load.started, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Started,
  }))
  .case(UserSettingsAction.load.done, (state, { result }) => ({
    ...state,
    settings: result,
    networkStatus: NetworkStatus.Done,
  }))
  .case(UserSettingsAction.load.failed, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Failed,
  }))
  .case(UserSettingsAction.saveSetting, (state, { key, value }) => ({
    ...state,
    settings: {
      ...state.settings,
      [key]: value,
    },
  }))
  .case(UserSettingsAction.destroy, () => initialState);
